import { createDuck } from 'redux-duck';
import { createStructuredSelector } from 'reselect';
import AlertSound from '../../assets/sound/pending_order.mp3';

const duck = createDuck('app/alert');

// Define initial state
const initialState = null;

// Define constants
export const SET_ALERT = duck.defineType('SET_ALERT');

// Define actions
export const actions = ({
  set: duck.createAction(SET_ALERT),
});

// Define selector
export const selector = createStructuredSelector({
  alert: (state) => state.alert,
});

// Define reducer
export default duck.createReducer({
  [SET_ALERT]: (state) => {
    const audio = new Audio(AlertSound);
    audio.play();
    audio.remove();
    return state;
  },
}, initialState);
